
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 18H1","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.438 17.516l5.76-6.417c.685-.684.8-1.68.256-2.224l-6.891-6.89c-.544-.544-1.54-.43-2.224.254l-8.677 8.677c-.685.685-.799 1.68-.255 2.224l3.531 4.376","stroke":"currentColor","stroke-width":"2","stroke-linecap":"square","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.618 8.753l-5.316 5.155-2.416-2.343","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    